import distributorKyiv from 'images/distributorKyiv.jpg';
import distributorWestern from 'images/distributorWestern.jpg';
import distributorBerlin from 'images/distributorBerlin.jpg';
import distributorKazakhstan from 'images/distributorKazakhstan.jpg';
import distributorMoldova from 'images/distributorMoldova.jpg';
import KyivRegion from 'images/KyivRegion.png';
import WesternRegion from 'images/WesternRegion.png';
import mapGermany from 'images/mapGermany.png';
import mapKazakhstan from 'images/mapKazakhstan.png';
import mapMoldova from 'images/mapMoldova.png';

export const contacts = [
    {
        country: 'Ukraine',
        regions: [
            {
                avatar: distributorKyiv,
                name: 'Maksym Zhuravel',
                description: 'Regional sales representative in Kyiv region.',
                phone: '+38 (050) 396 20 60',
                email: 'info@uniferx.com',
                region: 'Kyiv region',
                map: KyivRegion,
            },
            {
                avatar: distributorWestern,
                name: 'Yuriy Kukh',
                description:
                    'Regional sales representative: Vinnytsia, Volyn, Transcarpathian, Ivano-Frankivsk, Lviv, Rivne, Ternopil, Khmelnytsky and Chernivtsi regions',
                phone: '+38 (050) 396 20 60',
                email: 'info@uniferx.com',
                region: 'Western region',
                map: WesternRegion,
            },
        ],
    },
    {
        country: 'Germany',
        regions: [
            {
                avatar: distributorBerlin,
                name: 'Name',
                description: 'Regional sales representative...',
                phone: '+38 (050) 396 20 60',
                email: 'info@uniferx.com',
                region: 'Berlin',
                map: mapGermany,
            },
        ],
    },
    {
        country: 'Kazakhstan',
        regions: [
            {
                avatar: distributorKazakhstan,
                name: 'Name',
                description: 'Regional sales representative...',
                phone: '+38 (050) 396 20 60',
                email: 'info@uniferx.com',
                region: 'Berlin',
                map: mapKazakhstan,
            },
        ],
    },
    {
        country: 'Moldova',
        regions: [
            {
                avatar: distributorMoldova,
                name: 'Name',
                description: 'Regional sales representative...',
                phone: '+38 (050) 396 20 60',
                email: 'info@uniferx.com',
                region: 'Berlin',
                map: mapMoldova,
            },
        ],
    },
];
